<template>
   <div id="block_schedule_wrapper">
      
      <!-- Start/End Date Box -->
      <program-block-display-start-end-date
         :start="blockStartDate"
         :end="blockEndDate"
         @changeDateRange="updateDateRange"
      ></program-block-display-start-end-date>

      <!-- Start/End Time Box -->
      <program-block-display-start-end-time
         :startTime="blockStartTime"
         :endTime="blockEndTime"
         @changeStartTime="updateStartTime"
         @changeEndTime="updateEndTime"
      ></program-block-display-start-end-time>

      <div class="last-col col-md-3">
         <!-- Tags Box -->
         <program-block-display-tags></program-block-display-tags>

         <!-- Color Picker -->
         <program-block-display-color-picker
            :currColor="blockColor"
            @changeColor="updateColor"
         ></program-block-display-color-picker>
      </div>
   </div>
</template>

<script>
import ProgramBlockDisplayStartEndDate from './ProgramBlockDisplayStartEndDate';
import ProgramBlockDisplayStartEndTime from './ProgramBlockDisplayStartEndTime';
import ProgramBlockDisplayTags from './ProgramBlockDisplayTags';
import ProgramBlockDisplayColorPicker from './ProgramBlockDisplayColorPicker';
import 'buefy/dist/buefy.css';

import { mapActions, mapState } from 'vuex';

export default {

   props: {
      block: Object,
      workingRecid: Number | String,
      reset: Boolean
   },

   components: {
      ProgramBlockDisplayStartEndDate,
      ProgramBlockDisplayStartEndTime,
      ProgramBlockDisplayTags,
      ProgramBlockDisplayColorPicker
   },

   created() {
      let self = this;
      this.$on('changeDateRange', (range) => {
         self.updateDateRange(range);
      });
   },

   computed: {
      ...mapState('program_block', [
         'blockStartDate',
         'blockEndDate',
         'blockStartTime',
         'blockEndTime',
         'blockColor'
      ])
   },

   methods: {
      ...mapActions('program_block', [
         'changeBlockDateRange',
         'changeBlockStartTime',
         'changeBlockEndTime',
         'changeBlockColor'
      ]),

      /**
       * Update the block's date range
       */
      updateDateRange(e) {
         if (e) {
            this.changeBlockDateRange({range: e});
         }
      },

      /**
       * Update the block's start time
       */
      updateStartTime(startTime) {
         this.changeBlockStartTime({startTime: startTime});
      },

      /**
       * Update the block's end time
       */
      updateEndTime(endTime) {
         this.changeBlockEndTime({endTime: endTime});
      },

      /**
       * Update the block's color
       */
      updateColor(color) {
         this.changeBlockColor({color: color});
      },
      
   },
}
</script>

<style lang="scss" scoped>

#block_schedule_wrapper {
   display: flex;
   justify-content: center;

   .block-section {
      min-height: 600px;
   }
}

</style>


